import { ButtonAction } from '@/shared/types/button';
import { ClientType } from '@/shared/types/enum';

import {
  completeOnboardingStep,
  deletePortalLogo,
  deleteSigningAuthorisation,
  disconnectFreeAgent,
  disconnectXama,
  exportAccount,
  removeEmailDomain,
  requestGdprErasure,
  resendSigningAuthorisation,
  resetAccount,
  setupEmailDomain,
  verifyEmailDomain,
} from '@/front/actions/account';
import { createApiKey, revokeApiKey } from '@/front/actions/apiKeys';
import { archive } from '@/front/actions/archive';
import {
  createIndividualAssociation,
  createOrganisationAssociation,
  deleteAssociation,
  setPrimaryAssociation,
} from '@/front/actions/associations';
import { createAndLinkCompaniesHousePerson } from '@/front/actions/companiesHousePeople';
import { del, postForm, previewTemplate, save, submit } from '@/front/actions/forms';
import { importOrganisation, undoIndividualImport, undoOrganisationImport } from '@/front/actions/imports';
import { disableMfa, enableMfa, resendInvite, resetPassword, setTaskSummaryEmail } from '@/front/actions/members';
import { deleteLegacyPrimaryContact, migrateLegacyPrimaryContact } from '@/front/actions/primaryContact';
import { createServiceManager, deleteServiceManager } from '@/front/actions/serviceManagers';
import { resendSigningRequest } from '@/front/actions/signing';
import { createSmartTasks, toggleSetDate } from '@/front/actions/tasks';
import { close, expand } from '@/front/actions/ui';
import {
  linkXamaClient,
  openAmlRiskAssessmentModalAction,
  runIndividualAmlCheck,
  runOrganisationAmlCheck,
  searchXamaClients,
  syncIndividualAml,
  syncOrganisationAml,
  unlinkXamaClient,
} from '@/front/actions/xama';

type ActionHandler = (button: HTMLAnchorElement | HTMLButtonElement) => void | Promise<void>;

export const actionHandlers = {
  submit,
  post: postForm,
  save,
  delete: () => del(),
  expand: () => expand(),
  close: () => close(),
  resendInvite,
  exportAccount,
  resetPassword,
  enableMfa,
  disableMfa,
  setTaskSummaryEmail,
  importOrganisation,
  toggleSetDate,
  archive: (button) => archive(button, true),
  unarchive: (button) => archive(button, false),
  createSmartTasks,
  requestGdprErasure,
  createApiKey,
  revokeApiKey,
  createOrganisationServiceManager: (button) => createServiceManager(ClientType.Organisation, button),
  createIndividualServiceManager: (button) => createServiceManager(ClientType.Individual, button),
  deleteServiceManager,
  createIndividualAssociation,
  createOrganisationAssociation,
  deleteAssociation,
  setPrimaryAssociation,
  createAndLinkCompaniesHousePerson,
  deleteLegacyPrimaryContact,
  migrateLegacyPrimaryContact,
  undoOrganisationImport,
  undoIndividualImport,
  previewTemplate,
  resendSigningRequest,
  resendSigningAuthorisation,
  deleteSigningAuthorisation,
  setupEmailDomain,
  verifyEmailDomain,
  removeEmailDomain,
  disconnectXama,
  disconnectFreeAgent,
  runOrganisationAmlCheck,
  syncOrganisationAml,
  runIndividualAmlCheck,
  syncIndividualAml,
  searchXamaClients,
  linkXamaClient,
  unlinkXamaClient,
  openAmlRiskAssessmentModal: openAmlRiskAssessmentModalAction,
  completeOnboardingStep,
  deletePortalLogo,
  resetAccount,
} satisfies Record<ButtonAction, ActionHandler>;
